import React, { useMemo } from 'react';
import { PolylineF } from '@react-google-maps/api';

export const TrackLine = React.memo(({ 
  points, 
  type = 'recorded', 
  color = '#EF4444',
  strokeWidth = 4,
  opacity = 1,
  map,
  zIndex = 1
}) => {
  // Validate and transform points
  const validPoints = useMemo(() => {
    if (!points?.length) return [];
    
    const transformed = points
      .map(point => {
        const lat = Number(point?.latitude || point?.lat);
        const lng = Number(point?.longitude || point?.lng);
        
        if (isNaN(lat) || isNaN(lng) || !isFinite(lat) || !isFinite(lng)) {
          console.warn('[TrackLine] Invalid track point:', point);
          return null;
        }
        
        return { lat, lng };
      })
      .filter(Boolean);
      
    console.log('[TrackLine] Valid points:', transformed.length, 'out of', points.length);
    return transformed;
  }, [points]);

  if (validPoints.length < 2) {
    console.warn('[TrackLine] Not enough valid points to render track line');
    return null;
  }

  return (
    <PolylineF
      path={validPoints}
      visible={true}
      options={{
        strokeColor: color,
        strokeWeight: strokeWidth,
        strokeOpacity: opacity,
        geodesic: true,
        clickable: true,
        zIndex
      }}
    />
  );
});

TrackLine.displayName = 'TrackLine';

export default TrackLine;